import React from 'react';
import { OrganizationDetail } from 'components'

const MemberDetailPage = () => {
  return (
    <div>
      <OrganizationDetail />
    </div>
  )
}

export default MemberDetailPage;
